import { render, staticRenderFns } from "./AccettazioneSsnListaPageOld.vue?vue&type=template&id=e7d0cfae&scoped=true"
import script from "./AccettazioneSsnListaPageOld.vue?vue&type=script&lang=js"
export * from "./AccettazioneSsnListaPageOld.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7d0cfae",
  null
  
)

export default component.exports